module.exports = __webpack_public_path__ + "img/frame (215).a99880e1.jpg";